import {FILEVIEWER} from '../constants'
import axiosInstance from "../utils/axios.interceptor";

/***
 * Authenticates user
 */
export const viewFile = (uuid,filename) => {
  return async (dispatch) => {
    let response = await axiosInstance({
      method: 'POST',
      url: '/getDownloadLink',
      data: {"uuid": uuid,"filename":filename }
    });
    //This is to trigger componentWillReceiveProps()
    response.timestamp = new Date().toLocaleString();
      dispatch({type:FILEVIEWER,payload:response.data});
  };
};
